import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// Ensemble de validateurs réutilisables pour les formulaires de l'application
export class FormValidators {
  // SIRET: exactement 14 chiffres (les espaces sont automatiquement retirés)
  static siret(): ValidatorFn {
    const regex = /^\d{14}$/;
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value as string | null | undefined;
      if (!value) return null; // facultatif si non requis
      const sanitized = value.replace(/\s/g, '');
      if (sanitized !== value) {
        control.setValue(sanitized, { emitEvent: false });
      }
      return regex.test(sanitized) ? null : { siret: true };
    };
  }

  // Code postal FR: exactement 5 chiffres (les espaces sont automatiquement retirés)
  static codePostalFr(): ValidatorFn {
    const regex = /^\d{5}$/;
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value as string | null | undefined;
      if (!value) return null;
      const sanitized = value.replace(/\s/g, '');
      if (sanitized !== value) {
        control.setValue(sanitized, { emitEvent: false });
      }
      return regex.test(sanitized) ? null : { codePostal: true };
    };
  }

  // Téléphone FR basique: autorise espaces, points, tirets, doit contenir 10 chiffres (commençant par 0)
  static telephoneFr(): ValidatorFn {
    const digits = /\d/g;
    return (control: AbstractControl): ValidationErrors | null => {
      const value = (control.value as string | null | undefined) ?? '';
      if (!value) return null;
      const onlyDigits = (value.match(digits) || []).join('');
      // 10 chiffres, commence par 0
      return /^0\d{9}$/.test(onlyDigits) ? null : { telephone: true };
    };
  }

  // Numéro client: lettres/chiffres, tirets et slashs autorisés, 3 à 30 caractères
  static numeroClient(): ValidatorFn {
    const regex = /^[A-Za-z0-9\-\/]{3,30}$/;
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value as string | null | undefined;
      if (!value) return null;
      return regex.test(value) ? null : { numeroClient: true };
    };
  }
}
